import advancedFormat from 'dayjs/plugin/advancedFormat';

const setFormat = (dayjs) => {
  dayjs.extend(advancedFormat);

  return dayjs;
};

export default setFormat;
